<template>
    <div class="ForgotPassword">
        <div class="container">
            <h2>Forgot Password?</h2>
            <p>Please enter your email to receive a password reset link.</p>

            <el-form :model="form" status-icon ref="form" label-width="120px" class="demo-ruleForm" :rules="rules"
                @submit.native.prevent
                :label-position="labelPosition">

                <el-alert title="Email" type="error" v-if="error"
                    :description="error.message" show-icon>
                </el-alert>
                <el-alert title="Email Sent" type="success" v-if="success"
                    :description="success.message" show-icon>
                </el-alert>

                <el-form-item prop="email">
                    <el-input v-model="form.email" autocomplete="off" @keyup.enter.native="submitForm('form')" placeholder="Email Address" prefix-icon="el-icon-message"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="ForgotPassword__Button" type="primary" @click="submitForm('form')" :loading="loading">Reset Password</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'login',
        components: {
        },
        props: {},
        data: function () {
            return {
                labelPosition: 'top',
                form: {
                    email: '',
                },
                error: '',
                success: '',
                loading: false,
                rules: {
                    email: [
                        { required: true, message: 'Please input email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ]
                }
            }
        },

        created() {

        },
        methods: {
            submitForm(form) {
                event.preventDefault()
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.error = ''
                        this.success = ''
                        const promise = this.$store.dispatch('user/sendResetPasswordMail', this.form);
                        promise.then(result => {
                            this.success = result
                        }).catch(error => {
                            this.error = error
                        }).finally(() => {
                            this.loading = false
                        })
                    } else {
                        return false;
                    }
                });
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Forgot Password'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ForgotPassword {
        padding: 1em 0;

        h2, p {
            text-align: center;
        }

        form {
            max-width: 300px;
            margin: 0 auto;

            .el-form-item {
                margin-top: 1em!important;

                &.is-error {
                    margin-bottom: 1.5em!important;
                }
            }
        }

        &__Button {
            width: 100%;
        }
    }
</style>